<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>工单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="工厂" prop="factoryCode">
                <el-select v-model="searchform.factoryCode" type="text" filterable style="width: 100%"
                  @change="getworkshoplistsearch(searchform.factoryCode)">
                  <el-option v-for="(item, index) in factorylist" :key="index" :label="item.factory_name"
                    :value="item.factory_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车间" prop="workshopCode">
                <el-select v-model="searchform.workshopCode" type="text" filterable style="width: 100%"
                  @change="getworklinelistlistsearch(searchform.workshopCode)">
                  <el-option v-for="(item, index) in workshoplist" :key="(item, index)" :label="item.workshop_name"
                    :value="item.workshop_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产线" prop="worklineCode">
                <el-select v-model="searchform.worklineCode" type="text" filterable style="width: 100%">
                  <el-option v-for="(item, index) in worklinelist" :key="index" :label="item.workline_name"
                    :value="item.workline_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产状态" prop="status">
                <el-select v-model="searchform.status" type="text" style="width: 100%">
                  <el-option v-for="item in orderstatus" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单" prop="orderNo">
                <el-input v-model="searchform.orderNo" type="text" placeholder="请输入订单" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次" prop="batchNo">
                <el-input v-model="searchform.batchNo" type="text" placeholder="请输入批次" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select v-model="searchform.productCode" style="width: 100%" placeholder="请输入产品名称模糊匹配或者下拉选择"
                  :remote-method="getproductlist" filterable remote :loading="productloading" :disabled="show">
                  <el-option v-for="item in productlist" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产时间" prop="datelist">
                <el-date-picker v-model="searchform.datelist" style="width: 100%" type="daterange"
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="计划时间" prop="datelist2">
                <el-date-picker v-model="searchform.datelist2" style="width: 100%" type="daterange"
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数据状态" prop="workorder_status">
                <el-select v-model="searchform.workorder_status" type="text" style="width: 100%">
                  <el-option v-for="item in workorder_status" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" :offset="1">
              <el-button v-permission="['orderlist_select']" type="primary" icon="el-icon-search" @click="search">搜索
              </el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button v-permission="['orderlist_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
              <el-button v-permission="['orderlist_add']" type="primary"
                @click="(add.addshow = !add.addshow), ($refs.mychild.show = false)">新增工单</el-button>
              <el-button v-permission="['orderlist_select']" type="primary" @click="settatle()">设置表列显示</el-button>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <br id="A1" />
      <!-- 新增修改模块       -->
      <Order-Add :add="add" :search="search" />
      <Order-Update ref="mychild" :update="update" :search="search" />
      <update-Report ref="mychild2" :report="report" :search="search" />
      <TableHeader ref="TableHeader" :tablecolumn="tablecolumn" />
      <ExportList ref="myExportList" :search="search" />
      <InstorageList ref="myInstorage" :search="search" />
      <WorkorderPacklist ref="mypacklist" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <el-divider />
          <el-table id="parent" v-loading="listLoading" :stripe="true" element-loading-text="拼命加载中" :data="tableData"
            style="width: 100% " :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" border
            :default-sort="{ prop: 'produce_time', order: 'descending' }" @cell-click="danhang" max-height="500">
            <!-- sortable -->
            <el-table-column v-for="item in tablerow" :key="item.key" :prop="item.key" :label="item.label"
              :fixed="item.key == 'cz' ? 'right' : false" :min-width="item.width">
              <!-- <template slot-scope="props">
                <div v-if="item.key == 'reality_instorage_count'">
                  <el-link type="primary" v-permission="['orderlist_updatecount']" @click="toinstoragelist(props.row)">
                    {{ props.row.reality_instorage_count }}</el-link>
                </div>
                <div v-else>
                  {{ props.row[item.key] }}
                </div>
              </template> -->
            </el-table-column>

            <af-table-column prop="" label="操作" fixed="right">
              <template slot-scope="props">
                <!-- <div v-if="item.key !== 'cz'">
                  {{ props.row[item.key] }}
                </div> -->
                <el-popover placement="right" width="auto" trigger="click">
                  <div>

                    <el-button v-if="props.row.order_status == 1" v-permission="['orderlist_update']" type="primary"
                      @click="
                        getoutbilldata(props.row.orderno),
                        ($refs.mychild.show = true),
                        (add.addshow = false)
                        " class="bottstycz">
                      修改</el-button>
                    <el-button class="bottstycz" v-permission="['orderlist_delete']" type="danger"
                      @click="deletedate(props.row.id)">
                      删除</el-button>
                    <el-button class="bottstycz" v-if="props.row.order_status == 3"
                      v-permission="['orderlist_complete']" type="info" @click="completeorder(props.row)">结束工单
                    </el-button>
                    <el-button class="bottstycz" v-permission="['orderlist_export']" type="primary"
                      v-if="props.row.order_status >= 4" @click="toExportList(props.row)">导出
                    </el-button>
                    <el-button class="bottstycz" v-permission="['orderlist_details']" type="primary" size="mini"
                      @click="orderextendlist(props.row)">扩展</el-button>
                    <el-button class="bottstycz" v-permission="['orderlist_Packaging']" type="primary" size="mini"
                      @click="workorderpacklist(props.row)">包装关系</el-button>
                    <el-button class="bottstycz" v-permission="['orderlist_check']" v-if="props.row.quality_status == 0"
                      type="primary" size="mini" @click="batchqualitystatus(props.row)">质检审核</el-button>
                    <el-button class="bottstycz" type="primary" @click="updateaward(props.row)"
                      v-permission="['orderlist_Reports']">
                      质检报告
                    </el-button>
                    <el-button class="bottstycz" type="primary" @click="productionAdd(props.row)"
                      v-permission="['orderlist_add']">
                      生产入库
                    </el-button>
                    <el-button class="bottstycz" type="primary" @click="toinstoragelist(props.row)"
                      v-permission="['orderlist_updatecount']">
                      入库录入明细
                    </el-button>
                  </div>
                  <el-button slot="reference">按钮组</el-button>
                </el-popover>
              </template>
            </af-table-column>
          </el-table>
          <br />
          <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 40, 100]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count" @current-change="currentchange"
            @size-change="pagesize" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  orderquery,
  batchqualitystatus,
  factorylist,
  worklinelist,
  workshoplist,
  deletework,
  complete,
  downloadbackwork,
  receiptAdd
} from "@/api/plant";
import { productlist } from "@/api/base";
import TableHeader from "@/components/HeaderSearch/TableHeader";
import OrderAdd from "./components/OrderAdd";
import OrderUpdate from "./components/OrderUpdate";
import UpdateReport from "./components/UpdateReport";
import InstorageList from "./components/InstorageList";
import ExportList from "./components/exportList";
import WorkorderPacklist from "./components/workorderpacklist/workorderpacklist";
export default {
  name: "Orderlist",
  components: { OrderAdd, OrderUpdate, UpdateReport, TableHeader, InstorageList, WorkorderPacklist, ExportList },
  data() {
    return {
      tablerow: [],
      tablecolumn: [
        {
          label: "工厂",
          key: "factory_code",
          width: "130",
        },
        {
          label: "车间",
          key: "workshop_code",
          width: "130",
        },
        {
          label: "产线",
          key: "workline_code",
          width: "130",
        },
        {
          label: "班组",
          key: "workgroup_code",
        },
        {
          label: "订单",
          key: "orderno",
          width: "100",
        },
        {
          label: "产品",
          key: "product_name",
          width: "200",
        },
        {
          label: "规格",
          key: "specs",
          width: "80",
        },
        {
          label: "计划生产数量",
          key: "product_quantity",
          width: "100",
        },
        {
          label: "人工确认数量",
          key: "reality_instorage_count",
          width: "100",
        },
        {
          label: "批次号",
          key: "batchno",
          width: "160",
        },
        {
          label: "有效期",
          key: "period_date",
          width: "100",
        },
        {
          label: "1级采集数量",
          key: "package_level1_count",
          width: "90",
        },
        {
          label: "1级生产数量",
          key: "package_level1_produce",
          width: "90",
        },
        {
          label: "1级采集率",
          key: "harvest_rate1",
          width: "80",
        },
        {
          label: "2级采集数量",
          key: "package_level2_count",
          width: "90",
        },
        {
          label: "2级生产数量",
          key: "package_level2_produce",
          width: "90",
        },
        {
          label: "2级采集率",
          key: "harvest_rate2",
          width: "80",
        },
        {
          label: "3级采集数量",
          key: "package_level3_count",
          width: "90",
        },
        {
          label: "3级生产数量",
          key: "package_level3_produce",
          width: "90",
        },
        {
          label: "3级采集率",
          key: "harvest_rate3",
          width: "80",
        },
        {
          label: "4级采集数量",
          key: "package_level4_count",
          width: "90",
        },
        {
          label: "4级生产数量",
          key: "package_level4_produce",
          width: "90",
        },
        {
          label: "4级采集率",
          key: "harvest_rate4",
          width: "90",
        },
        {
          label: "5级采集数量",
          key: "package_level5_count",
          width: "90",
        },
        {
          label: "5级生产数量",
          key: "package_level5_produce",
          width: "90",
        },
        {
          label: "5级采集率",
          key: "harvest_rate5",
          width: "80",
        },
        {
          label: "生产开始时间",
          key: "produce_time",
          width: "160",
        },
        {
          label: "工单完成时间",
          key: "complete_time",
          width: "160",
        },
        {
          label: "计划开始时间",
          key: "plan_datetime1",
          width: "160",
        },
        {
          label: "计划完成时间",
          key: "plan_datetime2",
          width: "160",
        },
        {
          label: "计划生产日期",
          key: "plan_date",
          width: "160",
        },
        {
          label: "生产状态",
          key: "statusname",
          width: "160",
        },
        {
          label: "质检状态",
          key: "quality_statusmean",
          width: "160",
        },
      ],
      orderstatus: [
        {
          value: 1,
          label: "未下载",
        },
        {
          value: 2,
          label: "已下载",
        },
        {
          value: 3,
          label: "生产中",
        },
        {
          value: 4,
          label: "已完成",
        },
        {
          value: 9,
          label: "已关闭",
        },
      ],
      workorder_status: [
        {
          value: 0,
          label: "新数据",
        },
        {
          value: 1,
          label: "历史数据",
        },
      ],
      report: {
        id: null,
        show: false,
      },
      // 获取下拉，post请求
      productloading: false,
      show: false,
      productlist: [], // 产品列表下拉
      factory: {
        factory_uuid: null,
        factory_name: null,
        factory_code: null,
        factory_type: -1,
        factory_address: null,
        pageSize: 10000,
      },
      factorylist: [],
      factorysublist: [],
      workshop: {
        workshop_uuid: null,
        workshop_code: null,
        workshop_name: null,
        factory_code: null,
      },
      workshoplist: [],
      workline: {
        workshop_uuid: null,
        workshop_code: null,
        workshop_name: null,
        factory_code: null,
      },
      worklinelist: [],
      // 导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "工单列表",
      autoWidth: true,
      bookType: "xlsx",
      // 基础数据
      add: {
        addshow: false,
      },
      update: {
        form: {
          orderno: null,
          batchno: null,
          orderno_type: null,
          purchase_order: null,
          factory_code: null,
          workshop_code: null,
          workgroup_code: null,
          workline_code: null,
          entrust_code: null,
          plan_date: null,
        },
        // 表格数据
        tablelist: [],
        show: false,
      },
      orderNo: "",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      // 分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      // 搜索表单数据
      codearr: [],
      searchform: {
        productCode: null,
        workorder_status: 0,
        batchNo: "",
        factory_sub_code: null,
        factoryCode: null,
        workshopCode: "",
        workgroupCode: "",
        worklineCode: "",
        orderNo: "",
        datelist: [],
        datelist2: [],
        status: null,
        pageIndex: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    // 请求部门列表数据并且便利到表格
    // 工厂下拉
    factorylist({ pageSize: 10000 }).then((response) => {
      console.log(response.data);
      this.factorylist = response.data.data;
      for (let c = 0; c < this.factorylist.length; c++) {
        this.factorylist[c].factory_name =
          this.factorylist[c].factory_code +
          "|" +
          (this.factorylist[c].factory_sub_code || "") +
          "|" +
          this.factorylist[c].factory_name;
        this.factorylist[c].factory_code =
          this.factorylist[c].factory_code +
          "|" +
          (this.factorylist[c].factory_sub_code || "");
      }
    });
    this.search();
    this.getproductlist();
  },
  methods: {
    toExportList(row) {
      console.log(row);
      this.$refs.myExportList.row = Object.assign({}, row);
      this.$refs.myExportList.getTabledata();
    },
    toinstoragelist(row) {
      console.log(row);
      this.$refs.myInstorage.row = Object.assign({}, row);
      this.$refs.myInstorage.getTabledata();
    },
    settatle() {
      // 设置表头
      this.$refs.TableHeader.drawer = true;
    },
    getrowshow() {
      this.tablerow = this.$refs.TableHeader.tablerow;
      console.log(this.tablerow, "显示表头");
    },
    Tabledata(obj) {
      // 列表获取
      this.listLoading = true;
      orderquery(obj).then((response) => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.currentPage = response.data.page_index;
        this.total_count = response.data.total_count;
        this.listLoading = false;
        console.log(response.data);
      });
    },
    packdate(obj) {
      // 拼表格数据
      for (let i = 0; i < obj.length; i++) {
        obj[i].harvest_rate1 = obj[i].package_level1_produce == 0 ? '0%' : (obj[i].package_level1_count / obj[i].package_level1_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate2 = obj[i].package_level2_produce == 0 ? '0%' : (obj[i].package_level2_count / obj[i].package_level2_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate3 = obj[i].package_level3_produce == 0 ? '0%' : (obj[i].package_level3_count / obj[i].package_level3_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate4 = obj[i].package_level4_produce == 0 ? '0%' : (obj[i].package_level4_count / obj[i].package_level4_produce * 100).toFixed(2) + "%";
        obj[i].harvest_rate5 = obj[i].package_level5_produce == 0 ? '0%' : (obj[i].package_level5_count / obj[i].package_level5_produce * 100).toFixed(2) + "%";


        if (obj[i].min_package_unit_name) {
          obj[i].product_quantity =
            obj[i].product_quantity + obj[i].product_unit_cn;
        }

        // 把数据按规则拼起来  +'-' (obj[i].factory_sub_code||" ")
        obj[i].produce_time = this.$parseTime(obj[i].produce_time);
        obj[i].complete_time = obj[i].complete_time.replace(/T/, " ");
        obj[i].plan_date = obj[i].plan_date.replace(/T/, " ");
        obj[i].plan_datetime1 = obj[i].plan_datetime1.replace(/T/, " ");
        obj[i].plan_datetime2 = obj[i].plan_datetime2.replace(/T/, " ");
        obj[i].factory_code =
          (obj[i].factory_code || " ") +
          " " +
          (obj[i].factory_sub_code || " ") +
          " " +
          (obj[i].factory_name || " ");
        obj[i].workshop_code =
          (obj[i].workshop_code || " ") + (obj[i].workshop_name || " ");
        obj[i].workgroup_code =
          (obj[i].workgroup_code || " ") + (obj[i].workgroup_name || " ");
        obj[i].workline_code =
          (obj[i].workline_code || " ") + (obj[i].workline_name || " ");
        obj[i].product_name =
          (obj[i].product_code || " ") + " " + (obj[i].product_name || " ");
        obj[i].supplier_id = (obj[i].supplier_id || " ") + (obj[i].supplier_name || " ");
        if (obj[i].period_date == "0001-01-01") {
          obj[i].period_date = " ";
        }
        // 状态为已完成 才有完成时间
        if (obj[i].order_status !== 4) {
          obj[i].complete_time = " ";
        }
        if (obj[i].order_status < 3) {
          // 未生产  生产时间为空
          obj[i].produce_time = " ";
        }
        switch (obj[i].quality_status) {
          case 0:
            obj[i].quality_statusmean = "待质检";
            break;
          case 1:
            obj[i].quality_statusmean = "检验不合格";
            break;
          case 2:
            obj[i].quality_statusmean = "检验合格";
            break;
          default:
            break;
        }
        switch (obj[i].order_status) {
          case 1:
            obj[i].statusname = "未下载";
            break;
          case 2:
            obj[i].statusname = "已下载";
            break;
          case 3:
            obj[i].statusname = "生产中";
            break;
          case 4:
            obj[i].statusname = "已完成";
            break;
          case 9:
            obj[i].statusname = "已关闭";
            break;
          default:
            break;
        }
      }
    },
    // 质检报告修改操作
    updateaward(row) {
      this.$refs.mychild2.report.id = row.id;
      this.$refs.mychild2.report.quality_field1 = row.quality_field1 ? row.quality_field1 : '';
      this.$refs.mychild2.report.quality_field2 = row.quality_field2 ? row.quality_field2 : '';
      this.$refs.mychild2.report.quality_field3 = row.quality_field3 ? row.quality_field3 : '';
      this.$refs.mychild2.report.show = true;
    },
    orderextendlist(row) {
      // 扩展属性跳转
      console.log(row);
      this.$router.push({
        path: "/orderextendlist",
        query: {
          orderno: row.orderno,
          batchno: row.batchno,
          product_code: row.product_code,
          id: row.id,
        },
      });
    },
    workorderpacklist(row) {
      // 包装单位跳转
      console.log(row);
      this.$refs.mypacklist.dialogVisible = true;
      this.$refs.mypacklist.searchform = row;
      this.$refs.mypacklist.searchform.workorder_senior_id = row.id;
      this.$refs.mypacklist.getTabledata()
      // this.$router.push({
      //   path: "/workorderpacklist",
      //   query: {
      //     orderno: row.orderno,
      //     batchno: row.batchno,
      //     product_code: row.product_code,
      //     id: row.id,
      //   },
      // });
    },
    batchqualitystatus(row) {
      // 质检审核
      console.log(row);
      this.$confirm('工单质检审核', '提示', {
        confirmButtonText: '检验合格',
        cancelButtonText: '检验不合格',
        distinguishCancelAndClose: true,
        center: true,
        type: 'warning'
      }).then(() => {
        batchqualitystatus({
          quality_status: 2,
          id: row.id,
        }).then((response) => {
          if (response.status_code == 200) {
            this.$message({
              type: "success",
              message: "审核成功",
            });
            this.search();
          }
        });

      }).catch(action => {
        if (action === 'cancel') {
          batchqualitystatus({
            quality_status: 1,
            id: row.id,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "审核成功",
              });
              this.search();
            }
          })
        } else {
          this.$message({
            type: 'info',
            message: '取消操作'
          })
        }
      });
    },
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then((response) => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    // 搜索车间下拉
    getworkshoplistsearch(value) {
      this.searchform.workshopCode = "";
      this.searchform.worklineCode = "";
      this.codearr = value.split("|"); // 把工厂下拉gey 对应工厂编码跟子编码拆开存数组
      workshoplist({
        factory_code: this.codearr[0] || null,
        factory_sub_code: this.codearr[1] || null,
        pageSize: 1000,
      }).then((response) => {
        this.workshoplist = response.data.data;
        for (let i = 0; i < this.workshoplist.length; i++) {
          this.workshoplist[i].workshop_name =
            this.workshoplist[i].workshop_code + "|" + this.workshoplist[i].workshop_name;
        }
      });
    },
    // 产线下拉
    getworklinelistlistsearch(value) {
      this.searchform.worklineCode = "";
      worklinelist({ workshop_code: value, pageSize: 1000 }).then((response) => {
        this.worklinelist = response.data.data;
        for (let b = 0; b < this.worklinelist.length; b++) {
          this.worklinelist[b].workline_name =
            this.worklinelist[b].workline_code + "|" + this.worklinelist[b].workline_name;
        }
      });
    },
    // 搜索事件
    search() {
      typeof this.searchform.workshopCode;
      this.Tabledata({
        productCode: this.searchform.productCode,
        workorder_status: this.searchform.workorder_status,
        batchNo: this.searchform.batchNo,
        factoryCode: this.codearr[0] || null,
        factorySubCode: this.codearr[1] || null,
        workshopCode: this.searchform.workshopCode,
        workgroupCode: this.searchform.workgroupCode,
        worklineCode: this.searchform.worklineCode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        plan_date_start_time:
          this.searchform.datelist2 == null ? null : this.searchform.datelist2[0],
        plan_date_end_time:
          this.searchform.datelist2 == null ? null : this.searchform.datelist2[1],
        orderNo: this.searchform.orderNo,
        status: this.searchform.status,
        pageSize: this.searchform.pageSize,
      });
    },
    // 修改按钮 下载工单
    getoutbilldata(orderno) {
      document.getElementById("A1").scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth",
      });
      orderquery({
        orderno: orderno,
      }).then((response) => {
        this.$refs.mychild.getworkshoplistsearch(response.data.data[0].factory_code);
        this.$refs.mychild.getworklinelistlistsearch(response.data.data[0].workshop_code);
        this.$refs.mychild.form = response.data.data[0];
        this.$refs.mychild.tablelist = response.data.data;
        console.log(this.$refs.mychild.tablelist);
      });
    },
    // 删除按钮事件
    deletedate(id) {
      this.$confirm("此操作将永久删除该工单信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deletework({
            id: id,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 结束工单
    completeorder(row) {
      this.$confirm("此操作将结束该工单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          complete({
            orderno: row.orderno,
            batchno: row.batchno,
            product_code: row.product_code,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "操作失败!请检查字段",
              });
            }
          });
        })
    },
    // 重置按钮
    resetForm(formName) {
      this.codearr = [];
      this.$refs[formName].resetFields();
    },
    // 分页跳转事件
    currentchange(page_index) {
      this.searchform.pageIndex = page_index;
      this.Tabledata({
        productCode: this.searchform.productCode,
        workorder_status: this.searchform.workorder_status,
        batchNo: this.searchform.batchNo,
        factoryCode: this.codearr[0] || null,
        factorySubCode: this.codearr[1] || null,
        workshopCode: this.searchform.workshopCode,
        workgroupCode: this.searchform.workgroupCode,
        worklineCode: this.searchform.worklineCode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        orderNo: this.searchform.orderNo,
        status: this.searchform.status,
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize,
      });
    },
    // 分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.pageSize = page_size;
      this.search();
    },
    // 单行点击
    danhang(row) {
      this.orderNo = row.orderno;
      console.log(row);
    },
    // 导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        productCode: this.searchform.productCode,
        page_index: this.searchform.page_index,
        pageSize: this.total_count,
        workorder_status: this.searchform.workorder_status,
        batchNo: this.searchform.batchNo,
        factoryCode: this.codearr[0] || null,
        factorySubCode: this.codearr[1] || null,
        workshopCode: this.searchform.workshopCode,
        workgroupCode: this.searchform.workgroupCode,
        worklineCode: this.searchform.worklineCode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        orderNo: this.searchform.orderNo,
        status: this.searchform.status,
      };
      orderquery(obj).then((response) => {
        this.tableDataDownload = response.data.data;
        this.packdate(this.tableDataDownload);
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "工厂",
            "车间",
            "产线",
            "班组",
            "订单",
            "产品",
            "计划生产数量",
            "人工确认数量",
            "批次号",
            "有效期",
            "1级采集数量",
            "1级生产数量",
            "1级采集率",
            "2级采集数量",
            "2级生产数量",
            "2级采集率",
            "3级采集数量",
            "3级生产数量",
            "3级采集率",
            "4级采集数量",
            "4级生产数量",
            "4级采集率",
            "5级采集数量",
            "5级生产数量",
            "5级采集率",
            "生产开始时间",
            "工单完成时间",
            "计划开始时间",
            "计划完成时间",
            "计划生产日期",
            "生产状态",
            "质检状态",
          ];
          const filterVal = [
            "factory_code",
            "workshop_code",
            "workline_code",
            "workgroup_code",
            "orderno",
            "product_name",
            "product_quantity",
            'reality_instorage_count',
            "batchno",
            "period_date",
            "package_level1_count",
            "package_level1_produce",
            "harvest_rate1",
            "package_level2_count",
            "package_level2_produce",
            "harvest_rate2",
            "package_level3_count",
            "package_level3_produce",
            "harvest_rate3",
            "package_level4_count",
            "package_level4_produce",
            "harvest_rate4",
            "package_level5_count",
            "package_level5_produce",
            "harvest_rate5",
            "produce_time",
            "complete_time",
            "plan_datetime1",
            "plan_datetime2",
            "plan_date",
            "statusname",
            "quality_statusmean",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    exportdate(row) {
      console.log(row);
      downloadbackwork({
        orderno: row.orderno,
        batcno: row.batchno,
        product_code: row.product_code.split(" ")[0],
      })
        .then((response) => {
          const content = this.dataURLtoBlob(response.data);
          const blob = new Blob([content], { type: "application/zip" });
          const fileName = response.message;
          if ("download" in document.createElement("a")) {
            // IE下载
            const elink = document.createElement("a");
            elink.download = "生产工单.zip";
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            // 谷歌火狐下载
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
            if (window.navigator.msSaveBlob) {
              // ie下载
              console.log(window.navigator.msSaveBlob);
              try {
                window.navigator.msSaveBlob(blob, fileName);
              } catch (e) {
                console.log(e);
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    productionAdd(data) {
      const params = {
        orderno: data.orderno,
        product_code: data.product_code,
        batchno: data.batchno,
      }
      this.$prompt('请填写入库数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        params.qty = value
        console.log(params);

        receiptAdd(params).then(res => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.search()

        })


      });

    }
  },
};
</script>
<style scoped>
.rightclass {
  z-index: 9999;
}

.bottstycz {
  display: block !important;
  width: 150px;
  margin: 5px;
}
</style>
